import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_3: FaireProductEntity = {
  token: "starter_collection_3",
  type: "product",
  name: "'\"Drizzle\"'",
  brandName: "Graza",
  imageUrl: "",
  priceDollars: 12,
  msrpDollars: 24,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
